import React, { Component } from 'react'
import LoginOrJoin from '../login/LoginOrJoin'
import { Article, SpinnerCard } from '../common/Layout'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { checkoutRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'
import { loadDeliveryDropoffStart } from '../../redux/modules/delivery'
import { loadLocationStart } from '../../redux/modules/location'
import { loadOrderCartStart } from '../../redux/modules/cart'
import { locationRoute } from '../../routes/routes'
import ValidationModal from '../place-order/ValidationModal'

class CheckoutInterstitial extends Component {
  componentDidMount() {
    const {
      loadDeliveryDropoffStart,
      loadLocationStart,
      loadOrderCartStart
    } = this.props
    let {
      match: {
        params: { locationId = 0, dropoffId = 0 }
      }
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId) {
      loadLocationStart(locationId)
      if (dropoffId) {
        loadDeliveryDropoffStart(dropoffId)
        loadOrderCartStart(dropoffId)
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      loadLocationStart,
      loadOrderCartStart,
      isAuthenticated
    } = this.props
    let {
      match: {
        params: { locationId = 0, dropoffId = 0 }
      }
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId !== Number(prevProps.match.params.locationId)) {
      loadLocationStart(locationId)
    }
    if (dropoffId !== Number(prevProps.match.params.dropoffId)) {
      loadDeliveryDropoffStart(dropoffId)
      loadOrderCartStart(dropoffId)
    }
    if (isAuthenticated !== prevProps.isAuthenticated) {
      loadOrderCartStart(dropoffId)
    }
  }

  render() {
    const { isOrderCartLoading, orderItems, deliveryError } = this.props
    let {
      match: {
        params: { dropoffId = 0, locationId = 0 }
      }
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (deliveryError) {
      const serverMessage = deliveryError.response
        ? deliveryError.response.data
        : ''
      return (
        <ValidationModal
          serverMessage={serverMessage}
          locationId={locationId}
        />
      )
    }

    return (
      <Article>
        <SpinnerCard spinnerActive={isOrderCartLoading}>
          {!isOrderCartLoading && orderItems.length ? (
            <LoginOrJoin
              dropoffId={dropoffId}
              locationId={locationId}
              path={formatUrl(checkoutRoute.path, {
                locationId,
                dropoffId
              })}
              loginTitle="Login to Checkout"
              joinTitle="Register to Checkout"
              loginMessage="Login to checkout, and get lunch to your office."
              signupMessage="Sign up to checkout, and get lunch to your office."
            />
          ) : (
            <Redirect
              to={formatUrl(locationRoute.path, { locationId: locationId })}
            />
          )}
        </SpinnerCard>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const { isAuthenticated } = state.user
  const {
    orderCart: { orderItems },
    isOrderCartLoading
  } = state.cart
  const deliveryError = state.delivery.error
  return { isAuthenticated, orderItems, isOrderCartLoading, deliveryError }
}

const mapDispatchToProps = {
  loadDeliveryDropoffStart,
  loadLocationStart,
  loadOrderCartStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutInterstitial)
